import {
	BotType,
	GetBotLinkProps,
	getBotLink,
	getPartySectionLink,
	PartyPage,
	getMarketSectionLink,
	MarketPage,
	getMarketAlgosSectionLink,
	MarketAlgosPage,
} from "@/shared/routing";

import { CrumbHandle, IMenuItem, IPathParams, IRouteConfig } from "./types";

interface GetPartyMenuItemProps extends Pick<IMenuItem, "title" | "icon" | "indicationName"> {
	section: PartyPage;
}

export const getPartyMenuItem = ({ section, ...restParams }: GetPartyMenuItemProps): IMenuItem => ({
	...restParams,
	to: ({ partyUUID }: IPathParams) => getPartySectionLink({ partySection: section, partyUUID }),
});

interface GetMarketMenuItemProps extends Pick<IMenuItem, "title" | "icon" | "indicationName"> {
	section: MarketPage;
}

export const getMarketMenuItem = ({
	section,
	...restParams
}: GetMarketMenuItemProps): IMenuItem => ({
	...restParams,
	to: ({ partyUUID, marketUUID }: IPathParams) =>
		getMarketSectionLink({ marketSection: section, partyUUID, marketUUID }),
});

interface GetMarketAlgosMenuItemProps extends Pick<IMenuItem, "title" | "icon" | "indicationName"> {
	section: MarketAlgosPage;
}

export const getMarketAlgosMenuItem = ({
	section,
	...restParams
}: GetMarketAlgosMenuItemProps): IMenuItem => ({
	...restParams,
	to: ({ partyUUID, marketUUID }: IPathParams) =>
		getMarketAlgosSectionLink({ marketAlgosSection: section, partyUUID, marketUUID }),
});

interface GetBotMenuItemProps<T extends BotType>
	extends Pick<IMenuItem, "title" | "icon" | "indicationName">,
		Pick<GetBotLinkProps<T>, "botType" | "botTab"> {}

export const getBotMenuItem = <T extends BotType>({
	botType,
	botTab,
	...restParams
}: GetBotMenuItemProps<T>): IMenuItem => ({
	...restParams,
	to: ({ partyUUID, uuid }: IPathParams) => getBotLink({ botType, botTab, partyUUID, uuid }),
});

export const getDefaultCrumbConfig = (path: string): CrumbHandle => ({
	crumb: {
		path,
		title: path,
	},
});

export const removeAntLinkStyles = () => {
	for (const styleSheet of document.styleSheets) {
		if (
			styleSheet.ownerNode?.textContent?.includes("a:hover{color:var(--ant-color-link-hover);}")
		) {
			styleSheet.ownerNode.remove();
			break;
		}
	}
};

export const appendCssLink = (url: string) => {
	const styles = document.createElement("link");

	styles.href = url.replace("index.mjs", "style.css");

	styles.rel = "stylesheet";
	styles.type = "text/css";

	document.head.appendChild(styles);
};

export const filterHiddenRoutes = (routes: IRouteConfig[]) =>
	routes.filter(({ hide }) => hide === undefined || !hide);
